import { useQuery } from '@tanstack/react-query'
import { useTypedApiClient } from 'hooks/useTypedApiClient'
import { type ContestType } from 'types/api'

export const useGetPassportGames = () => {
  const get = useTypedApiClient({
    path: '/admin/contests/type/{contestType}',
    method: 'get',
  })

  return useQuery({
    queryKey: ['/contests/type/{contestType}'],
    queryFn: async () => {
      const { data } = await get({ contestType: 'PassportGame' as ContestType })
      return data
    },
  })
}
